import React from 'react'
import {Polyline} from 'react-leaflet'
import {connect} from 'react-redux'

const Paths = ({paths, ...props}) =>  <Polyline color='blue' positions={paths} {...props}/>

const mapStateToProps = state => ({paths: state.pathsBetweenPoisAndEstate})

export default connect(mapStateToProps)(Paths)



/** WEBPACK FOOTER **
 ** ./app/components/Paths.jsx
 **/